import { Component } from '@angular/core';

import { AbstractPageForm } from '../../pages/page-form.abstract';

@Component({
    selector: 'pk-broker-market-recommendations',
    templateUrl: './market-recommendations.component.html',
    styleUrls: ['./market-recommendations.component.scss'],
    standalone: false
})
// PKC-15997: Removed from contract info page in favor of layered purchasing icon but possibility of
//	adding it back in due to uncertainty. Keeping the component for now.
export class MarketRecommendationsComponent extends AbstractPageForm {
	public email = 'sales@powerkiosk.com';
}
